export default "assets/images/price-d3dff71c.svg";